export default "__VITE_ASSET__BLrMaPCj__"